export class Solicitacao {
  public icon?: string;
  public tipo?: string;
  public id?: string;
  public lat: number;
  public lng: number;
  public label?: string;
  public protocolo?: string;
  public endereco?: string;
  public despacho?: Array<String>;
  public andamento?: Array<String>;
  public solicitacoes_tipos?: Array<String>;
  public solicitacoes_subtipos?: Array<String>;
  public envolvido?: Array<String>;
  public historico?: any;
  public andamentos_despachos_ordenados?: Array<String>;
  //public origemid : number;
  public estado?: string;
  public cidade?: string;
  public bairro?: string;
  public logradouro?: string;
  public numero?: number;
  public numeroChamado?: string;
  public complemento?: string;
  public situacao_do_ultimo_andamento?: string;
  public solicitacoes_tipo_id?: string;
  public isOpen?: boolean;


  public draggable: boolean;
  public tipoSolicitacaoId?: string;
  public subTipoSolicitacaoId?: string;
  public data_solicitacao?: string;
  public prioridade?: string
  public unidade?: string;
  public situacao?: string;
  public situacaoView?: string;
  public grupo?: string;
  public codigo?: string;
  public solicitacao?: string;
  public DescricaoCodigo?: string;
  public descricao?: string;
  public animation?: string;
  public descricaoGrupo?: string;
  public addListener?: Function;

}



// WEBPACK FOOTER //
// ./src/app/models/Solicitacao.ts